// feature157-heatmap-ai-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "A IA está lendo o movimento das últimas 4 semanas…": "La IA está leyendo el movimiento de las últimas 4 semanas…",
    "Sugestão gerada por IA com o movimento de %{arg1} a %{arg2} · atualiza toda segunda": "Sugerencia generada por IA con el movimiento del %{arg1} al %{arg2} · se actualiza cada lunes",
    "Ver comentários": "Ver comentarios",
    "Últimas 4 semanas": "Últimas 4 semanas",
};

export default catalogo;
